export class SearchModel {
  constructor(searchForIn: string, searchInIn: string) {
    this.searchFor = searchForIn;
    this.searchIn = searchInIn;
  }
  public searchFor: string;
  public searchIn: string;
}

